<script setup lang="ts">
import { PayoutsEmbed } from '@/Pejer/tables/Payouts'
import { ChevronDown } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from 'pejer/src/components/ui/dropdown-menu'
import PayoutPaymentVoucherModal from './PayoutPaymentVoucherModal.vue'

defineProps<{
  payout: PayoutsEmbed.ListItem
}>()
</script>
<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button variant="ghost" class="h-8 hover:bg-slate-200">
        <span>Valg</span>
        <ChevronDown class="w-4 h-4 shrink-0 ml-1" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuLabel>Valg</DropdownMenuLabel>
      <DropdownMenuGroup>
        <DropdownMenuItem class="p-0">
          <PayoutPaymentVoucherModal :payoutId="payout.payoutId">
            <Button
              @click.prevent.stop
              class="p-2 rounded-sm w-full m-0 cursor-pointer flex-1 justify-start hover:bg-slate-100"
              variant="ghost"
            >
              Se utbetalingsbilag
            </Button>
          </PayoutPaymentVoucherModal>
        </DropdownMenuItem>
      </DropdownMenuGroup>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
